import { NavLink, useLocation } from "react-router-dom";
import { 
  LayoutDashboard, 
  FileText, 
  Scale, 
  Download, 
  Upload,
  Lightbulb
} from "lucide-react";
import { API } from "@/utils/constants";

const Sidebar = () => {
  const location = useLocation();
  
  const navItems = [
    { path: '/', label: 'Dashboard', icon: LayoutDashboard },
    { path: '/insights', label: 'Insights', icon: Lightbulb },
    { path: '/rules', label: 'Pay Rules', icon: FileText },
    { path: '/state-laws', label: 'State Laws', icon: Scale },
    { path: '/upload', label: 'Upload Configurations', icon: Upload },
  ];

  return (
    <aside 
      data-testid="sidebar"
      className="fixed left-0 top-0 h-screen w-64 flex flex-col shadow-lg bg-slate-900 border-r border-slate-700"
    >
      {/* Logo Section */}
      <div className="p-5 border-b border-slate-700">
        <img 
          src="/wagelens-logo.svg" 
          alt="WageLens" 
          className="h-10 w-auto brightness-110"
        />
        {/* Tagline */}
        <div className="mt-3 flex items-center gap-2">
          <div className="w-1.5 h-1.5 rounded-full bg-[#2EC4B6] animate-pulse"></div>
          <p className="text-[10px] uppercase tracking-widest font-medium text-slate-500">
            AI-Powered Compliance
          </p>
        </div>
      </div>

      {/* Navigation */}
      <nav className="flex-1 p-4 bg-gradient-to-b from-slate-900 to-slate-800">
        <ul className="space-y-1.5">
          {navItems.map(({ path, label, icon: Icon }) => (
            <li key={path}>
              <NavLink
                to={path}
                data-testid={`nav-${label.toLowerCase().replace(/\s+/g, '-')}`}
                className={({ isActive }) =>
                  `flex items-center gap-3 px-4 py-3 rounded-xl transition-all duration-200 ${
                    isActive || (path === '/' && location.pathname === '/')
                      ? 'bg-gradient-to-r from-[#2EC4B6] to-[#26a89c] text-slate-900 shadow-lg shadow-[#2EC4B6]/25 font-semibold'
                      : 'text-slate-400 hover:bg-slate-800 hover:text-[#2EC4B6] hover:translate-x-1'
                  }`
                }
              >
                <Icon className="w-5 h-5" />
                <span className="font-medium">{label}</span>
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>

      {/* Bottom Section */}
      <div className="p-4 border-t border-slate-700 bg-slate-900">
        {/* Export Button */}
        <a
          href={`${API}/compliance/export`}
          download
          data-testid="export-btn"
          className="flex items-center justify-center gap-2 w-full px-4 py-3 bg-slate-800 hover:bg-slate-700 border border-slate-600 rounded-xl text-sm font-semibold transition-all duration-200 text-slate-300 hover:text-white"
        >
          <Download className="w-4 h-4" />
          Export Report
        </a>
      </div>
    </aside>
  );
};

export default Sidebar;
